import React, { useState } from "react";
import "./OnboardingCard.css";
import { marcarCuestionarioVisitado } from "../../services/notificaciones";
import { useNavigate } from "react-router-dom";

const OnboardingCard = ({ estado, onNavigate }) => {
  const [tooltipAbierto, setTooltipAbierto] = useState(null);
  const navigate = useNavigate();
  if (!estado) return null;

  const { porcentaje, completados, total, siguiente_paso, hitos } = estado;
  
  const toggleTooltip = (e, key) => {
    e.stopPropagation();
    setTooltipAbierto(tooltipAbierto === key ? null : key);
  };

  // Metadata de los 5 pasos: label y ruta a donde mandar
  const PASOS = [
  {
    key: "perfil_completo",
    label: "Completa tu perfil",
    url: "/dashboard/configuracion/perfil",
    ayuda: "Llena todos tus datos personales, teléfono, sexo, fecha de nacimiento, dirección y cédula profesional, etc. Si tienes especialidad o subespecialidad, agrega las cédulas correspondientes. La dirección es necesaria para que aparezca en las recetas.",
  },
  {
    key: "receta_configurada",
    label: "Configura tu receta",
    url: "/dashboard/configuracion/receta",
    ayuda: "Personaliza el diseño de tus recetas: datos visibles, acomodo, tamaños, letras y demás elementos para adaptarlas a tu forma de trabajar. Si lo deseas, también puedes subir tu logo para darles una imagen más profesional.",
  },
  {
    key: "horario_configurado",
    label: "Configura tu horario y recordatorios",
    url: "/dashboard/citas",
        ayuda: "Configura tu horario de atención por día y activa confirmaciones y recordatorios por WhatsApp para tus citas. Aquí también puedes activar tu link de agendamiento en línea para que tus pacientes agenden solos, y la ficha previa para que llenen sus datos antes de su primera consulta.",
    abreModalAgenda: true,
  },
  {
    key: "cuestionario_visitado",
    label: "Personaliza tu cuestionario",
    url: "/dashboard/configuracion/cuestionario",
        ayuda: "Personaliza tu cuestionario, ya sea más breve o más detallado, y define qué preguntas quieres incluir dentro de tus historias clínicas y consultas, según tu especialidad y tu forma de trabajo. Aquí también puedes activar plantillas rápidas y ajustar las sugerencias históricas. Hasta arriba de esta pantalla está el switch Certificado NOM-024: para que tu expediente opere bajo la versión certificada, debes activarlo y completar los datos que se requieren. Si vas a migrar pacientes o consultas anteriores, hazlo antes de activarlo. Más detalle en el paso 5 del Centro de Ayuda.",
    soloVisita: true,
  },
  {
    key: "primer_paciente",
    label: "Crea tu primer paciente",
    url: "/dashboard/historias-clinicas",
    ayuda: "Registra al primer paciente en tu consultorio. Tienes dos caminos: darlo de alta primero (completo o con \"registro express\") y después seleccionarlo al crear su cita, o agendarlo rápido desde Citas como persona nueva, solo con nombre y contacto, y hacer su alta cuando llegue a consulta. En cualquier caso, debes completar todos sus datos antes de iniciar su consulta.",
  },
  {
    key: "primera_cita",
    label: "Agenda tu primera cita",
    url: "/dashboard/citas",
    ayuda: "Ve al calendario y crea una cita. Puede ser con un paciente que ya tiene expediente, con una persona nueva (solo con nombre y contacto, sin darla de alta todavía) o una cita personal para bloquear tiempo. Las citas que tus pacientes agenden desde tu link también aparecen aquí. Cuando llegue la cita, puedes iniciar la consulta directo desde la agenda.",
  },
  {
    key: "primer_expediente",
    label: "Crea tu primer expediente",
    url: "/dashboard/historias-clinicas",
        ayuda: "Inicia la consulta desde Expedientes Clínicos o directo desde la cita en tu agenda, y completa la información médica necesaria, como antecedentes, signos vitales, exploración física, laboratorios, diagnóstico y tratamiento. Registra cada consulta el mismo día en que atiendes al paciente. Aquí se concentra el seguimiento clínico de cada paciente: es el corazón de Salvir.",
  },
  {
    key: "primera_receta",
    label: "Genera tu primera receta",
    url: "/dashboard/recetas",
    ayuda: "Crea una receta seleccionando primero al paciente y después la consulta correspondiente. Salvir tomará automáticamente la información que hayas capturado en esa consulta para prellenar la receta y que solo completes o ajustes lo necesario. La dirección de tu perfil se usa automáticamente.",
  },
  {
    key: "pagos_configurados",
    label: "Activa tu suscripción",
    url: "/dashboard/configuracion/pago",
    ayuda: "Agrega tu método de pago para activar tu suscripción y seguir usando Salvir cuando termine tu prueba gratuita. Puedes gestionarla o cancelarla cuando quieras.",
  },
];


  return (
    <div className="onboarding-card">
      <div className="onboarding-header">
        <h3>Empieza a usar Salvir</h3>
         <div className="onboarding-progress-meta">
          <span className="onboarding-progress-percent">
            {porcentaje}% completado
          </span>
          <span className="onboarding-progress-text">
            {completados} de {total}
          </span>
        </div>
      </div>

      <div className="onboarding-progress-bar">
        <div
          className="onboarding-progress-fill"
          style={{ width: `${porcentaje}%` }}
        />
      </div>
      <p className="onboarding-pasos-helper">
        Da clic en el paso que quieras hacer ahora:
      </p>
       <button
        className="onboarding-video-link"
        onClick={() => navigate("/dashboard/ayuda", { state: { abrirVideo: true } })}
      >
        ▶ Salvir en 3 minutos - Video introductorio
      </button>
      <div className="onboarding-pasos">
        {PASOS.map((paso) => {
          const completo = hitos[paso.key];
          return (
            <div
              key={paso.key}
              className={`onboarding-paso ${completo ? "completo" : "pendiente"} clickeable`}
              onClick={() => {
                if (paso.soloVisita) {
                  marcarCuestionarioVisitado().catch(() => {});
                }
                 if (paso.abreModalAgenda) {
                  navigate(paso.url, { state: { abrirConfigAgenda: true } });
                  return;
                }
                onNavigate(paso.url);
              }}
            >
              <span className="onboarding-paso-icon">
                {completo ? "✓" : "○"}
              </span>
              <span className="onboarding-paso-label">{paso.label}</span>
              <span
                className="onboarding-paso-info"
                onClick={(e) => toggleTooltip(e, paso.key)}
                title="¿Qué incluye este paso?"
              >
                ⓘ
                {tooltipAbierto === paso.key && (
                  <span
                    className="onboarding-tooltip"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {paso.ayuda}
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>

      {siguiente_paso && (
          <div className="onboarding-sugerencia">
            <span className="onboarding-sugerencia-label">Siguiente paso sugerido:</span>
            <button
              className="onboarding-cta"
              onClick={() => onNavigate(siguiente_paso.cta_url)}
            >
              {siguiente_paso.cta_texto} →
            </button>
          </div>
        )}
    </div>
  );
};

export default OnboardingCard;